"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Accessibility() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.18
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.18
  });
  const {
    ref: ruleRef,
    isVisible: ruleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.18
  });
  const baseTransition = "transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]";
  const hidden = "opacity-0 translate-y-4";
  const shown = "opacity-100 translate-y-0";
  return <section data-section-id="8340" id="βελτίωση-πρότυπα-προσβασιμότητας" className="bg-background text-foreground py-32 md:py-44 lg:py-56 px-5 md:px-8 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-6 lg:col-start-4 flex flex-col items-start gap-8 md:gap-12">
            <div ref={eyebrowRef} className={`${baseTransition} ${eyebrowVisible ? shown : hidden}`} style={{
            transitionDelay: "0ms"
          }}>
              <span className="font-default uppercase text-muted-foreground" style={{
              fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
              letterSpacing: "0.22em",
              fontWeight: 500,
              lineHeight: 1
            }}>
                Δέσμευση Προσβασιμότητας
              </span>
            </div>

            <h2 ref={headlineRef} className={`${baseTransition} ${headlineVisible ? shown : hidden} font-default font-normal text-foreground`} style={{
            fontSize: "clamp(2rem, 3.8vw, 3.5rem)",
            letterSpacing: "-0.015em",
            lineHeight: 1.06,
            transitionDelay: "120ms"
          }}>
              Η ψηφιακή εμπειρία{" "}
              <em className="italic font-default" style={{
              color: "var(--primary)"
            }}>
                ανήκει σε όλους
              </em>
              {" "}χωρίς εξαιρέσεις.
            </h2>

            <p ref={bodyRef} className={`${baseTransition} ${bodyVisible ? shown : hidden} font-default font-normal text-foreground`} style={{
            fontSize: "clamp(1.25rem, 1.6vw, 1.625rem)",
            letterSpacing: "-0.005em",
            lineHeight: 1.5,
            transitionDelay: "240ms"
          }}>
              Σχεδιάζουμε με γνώμονα την καθολική πρόσβαση, διασφαλίζοντας ότι κάθε χρήστης μπορεί να πλοηγηθεί, να κατανοήσει και να αλληλεπιδράσει με τις υπηρεσίες μας. Εφαρμόζουμε αυστηρά πρότυπα WCAG, μετατρέποντας την τεχνολογία σε ένα εργαλείο συμπερίληψης που καταργεί τα εμπόδια και ενισχύει την ισότιμη συμμετοχή για κάθε άτομο.
            </p>

            <div ref={ruleRef} className={`${baseTransition} ${ruleVisible ? shown : hidden} w-full h-px bg-border`} style={{
            transitionDelay: "360ms"
          }} aria-hidden="true" />

            <p ref={captionRef} className={`${baseTransition} ${captionVisible ? shown : hidden} font-default text-muted-foreground`} style={{
            fontSize: "clamp(0.8125rem, 0.85vw, 0.875rem)",
            letterSpacing: "0.01em",
            lineHeight: 1.5,
            fontWeight: 400,
            transitionDelay: "480ms"
          }}>
              {"— Ομάδα Σχεδιασμού & Προσβασιμότητας"}
            </p>
          </div>
        </div>
      </div>
    </section>;
}